import { AppConfig } from '@dh-io-emh/config-types';
import { createProductApiBff } from './product.api.bff';
import { createProductApiDcp } from './product.api.dcp';
import { type ProductApi } from './product.api.types';

export { type ProductApi };

export const createProductApi = ({ config }: { config: AppConfig }): ProductApi => {
  if (config.pdp.bffService.enabled || config.srp.bffService.enabled) {
    return {
      ...createProductApiDcp({ config }),
      ...createProductApiBff({ config }),
    };
  } else {
    return createProductApiDcp({ config });
  }
};
